import { addCache } from 'api/caching'
import {
    CerebroApiOptions,
    CerebroPaginatedResponse,
    CerebroResourceResponse,
} from 'api/Cerebro/types'
import { orgScopedApiClient } from 'api/orgScopedClient'
import { Report } from 'types'

import { getCerebroHeaders } from '../Cerebro/headers'

import { BannerRequestBody } from './types'

export const getSBPurchasedProductsFacts = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroPaginatedResponse<any>> =>
    orgScopedApiClient.post(
        '/api/sb_purchased_product_facts/aggregate/banner/',
        params,
        {
            headers: getCerebroHeaders(options.headers),
        }
    )
addCache(getSBPurchasedProductsFacts)

export const getSBPurchasedProductsFactsExport = (
    params: BannerRequestBody
): Promise<CerebroResourceResponse<Report>> =>
    orgScopedApiClient.post(
        '/api/sb_purchased_product_facts/aggregate/banner/export/',
        params
    )
